import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string, fallback = true): boolean {
  return useSyncExternalStore(
    (cb) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', cb);
      return () => mql.removeEventListener('change', cb);
    },
    () =>
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia(query).matches
        : fallback,
    () => fallback,
  );
}

/** Dizajn: ≥ 1200 px je „širok“ (puni sidebar, Ctrl K, tekst sinhronizacije). */
export const useWide = () => useMediaQuery('(min-width: 1200px)');
